import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0109ade0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0109ade0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0109ade0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chad/git/CirrusLink/Chariot-UI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0109ade0')) {
      api.createRecord('0109ade0', component.options)
    } else {
      api.reload('0109ade0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0109ade0&scoped=true", function () {
      api.rerender('0109ade0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LicenseBanner/index.vue"
export default component.exports